/**
 * @generated SignedSource<<4b0970cfd295aba9308b882c96f6a3ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomEditMain_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EditorJsField_data" | "RoomEditMainGeneral_data" | "useEditorJsField_data" | "useTranslatableField_data">;
  readonly " $fragmentType": "RoomEditMain_data";
};
export type RoomEditMain_data$key = {
  readonly " $data"?: RoomEditMain_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomEditMain_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomEditMain_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditorJsField_data"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoomEditMainGeneral_data"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useTranslatableField_data"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useEditorJsField_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "41b38a3ce66b7b15efc12c4aa446dd96";

export default node;
